<!-- Header con gradiente -->
<div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 20px 24px; border-bottom: 2px solid #bbf7d0; display: flex; align-items: center; justify-content: space-between;">
  <div style="display: flex; align-items: center; gap: 10px;">
    <mat-icon style="font-size: 24px; width: 24px; height: 24px; color: #1C593D;">person_add</mat-icon>
    <h2 style="margin: 0; font-size: 1.1rem; font-weight: 800; color: #1e5a3f;">
      {{ esUpdate ? 'Actualizar beneficiario' : 'Nuevo beneficiario' }}
    </h2>
  </div>
  <button type="button" (click)="cancel()"
    style="display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border: 1px solid #d1d5db; border-radius: 8px; background: white; cursor: pointer;"
    onmouseover="this.style.background='#fef2f2'" onmouseout="this.style.background='white'">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">close</mat-icon>
  </button>
</div>

<!-- Contenido -->
<div style="padding: 20px 24px; overflow-y: auto; max-height: calc(90vh - 140px);">

  <!-- Vista inicial: Selección tipo beneficiario y forma de envío -->
  <div *ngIf="!viewForm">
    <p style="font-size: 0.8rem; color: #6b7280; margin: 0 0 20px; text-align: center;">Configura los datos de tu beneficiario</p>

    <!-- Tipo de beneficiario -->
    <div style="margin-bottom: 20px;">
      <label style="display: block; font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 8px; text-align: center;">
        ¿Qué tipo de beneficiario deseas agregar?
      </label>
      <mat-radio-group
        class="flex justify-center gap-4"
        [value]="tipoBeneficiario"
        (change)="onTipoBeneficiarioChange($event.value)">
        <mat-radio-button [value]="0">Persona</mat-radio-button>
        <mat-radio-button [value]="1">Empresa</mat-radio-button>
      </mat-radio-group>
    </div>

    <!-- Forma de envío -->
    <div style="margin-bottom: 4px;">
      <label style="display: block; font-size: 0.8rem; font-weight: 700; color: #1e5a3f; margin-bottom: 8px; text-align: center;">
        Elige tu forma de envío
      </label>
      <mat-radio-group
        class="flex justify-center gap-4"
        [value]="formaEnvio"
        (change)="onFormaEnvioChange($event.value)">
        <mat-radio-button [value]="0">Transferencia Bancaria</mat-radio-button>
        <mat-radio-button [value]="1">Pago Móvil</mat-radio-button>
      </mat-radio-group>

      <!-- Aviso Pago Móvil bloqueado por monto: solo cuando eligen Pago Móvil -->
      <div *ngIf="formaEnvio === 1 && pagoMovilBloqueadoPorMonto"
        style="display: flex; align-items: center; gap: 8px; background: #ffebee; border: 1px solid #ef5350; border-radius: 12px; padding: 12px 16px; margin-top: 16px;">
        <span style="font-size: 20px;">⚠️</span>
        <span style="font-size: 14px; color: #c62828; font-weight: 500;">
          <strong>Pago Móvil</strong> no está disponible para montos superiores a
          <strong>{{ pagoMovilMontoMax | number:'1.0-0' }}</strong> Bs.
        </span>
      </div>

      <!-- Aviso Pago Móvil no disponible / restringido a Banesco -->
      <div *ngIf="formaEnvio === 1 && mensajePagoMovil"
        style="display: flex; align-items: center; gap: 8px; background: #fff3e0; border: 1px solid #ffb74d; border-radius: 12px; padding: 12px 16px; margin-top: 16px;">
        <span style="font-size: 20px;">📱</span>
        <span style="font-size: 14px; color: #e65100; font-weight: 500;">{{ mensajePagoMovil }}</span>
      </div>
    </div>
  </div>

  <!-- FORMULARIO -->
  <div *ngIf="viewForm">
    <!-- Motivo del último intento fallido de guardar -->
    <div *ngIf="mensajeError" role="alert" aria-live="assertive"
      style="display: flex; align-items: flex-start; gap: 10px; margin-bottom: 16px; padding: 12px 14px; background: #fef2f2; border: 1px solid #fecaca; border-left: 4px solid #dc2626; border-radius: 10px;">
      <mat-icon style="color: #dc2626; font-size: 20px; width: 20px; height: 20px; flex-shrink: 0;">error_outline</mat-icon>
      <span style="color: #991b1b; font-size: 0.85rem; line-height: 1.45;">{{ mensajeError }}</span>
    </div>

    <!-- Badges info -->
    <div style="display: flex; justify-content: center; gap: 10px; flex-wrap: wrap; margin-bottom: 20px;">
      <span style="display: inline-flex; align-items: center; gap: 4px; background: #f0fdf4; border: 1px solid #bbf7d0; padding: 4px 12px; border-radius: 20px; font-size: 0.72rem; font-weight: 600; color: #1e5a3f;">
        <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #1C593D;">{{ tipoBeneficiario === 0 ? 'person' : 'business' }}</mat-icon>
        {{ tipoBeneficiario === 0 ? 'Persona' : 'Empresa' }}
      </span>
      <span style="display: inline-flex; align-items: center; gap: 4px; background: #f0fdf4; border: 1px solid #bbf7d0; padding: 4px 12px; border-radius: 20px; font-size: 0.72rem; font-weight: 600; color: #1e5a3f;">
        <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #1C593D;">{{ formaEnvio === 0 ? 'account_balance' : 'phone_android' }}</mat-icon>
        {{ formaEnvio === 0 ? 'Transferencia Bancaria' : 'Pago Móvil' }}
      </span>
    </div>

    <form
      (ngSubmit)="guardarBeneficiario()"
      *ngIf="formCuenta"
      [formGroup]="formCuenta">

      <!-- COUNTRY -->
      <div class="grid grid-cols-1 gap-4" style="margin-bottom: 8px;">
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>País</mat-label>
          <mat-select formControlName="pais" [disabled]="true">
            <mat-option *ngFor="let pais of paisesActivos" [value]="pais.codigoPais">
              {{ pais.nombre | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <h3 style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f; margin: 0 0 12px;">Datos del beneficiario</h3>

      <!-- DATA NAME PERSON -->
      <div *ngIf="tipoBeneficiario === 0" class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Nombre</mat-label>
          <input type="text" matInput formControlName="nombre" placeholder="Ingresa tu nombre" autocomplete="off"
            (input)="limpiarNombre($event, 'nombre')" (compositionend)="limpiarNombre($event, 'nombre')">
          <mat-error *ngIf="getErrorMessageName('nombre')">{{ getErrorMessageName('nombre') }}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Apellidos</mat-label>
          <input type="text" matInput formControlName="apellidos" placeholder="Ingresa tu apellido" autocomplete="off"
            (input)="limpiarNombre($event, 'apellidos')" (compositionend)="limpiarNombre($event, 'apellidos')">
          <mat-error *ngIf="getErrorMessageName('apellidos')">{{ getErrorMessageName('apellidos') }}</mat-error>
        </mat-form-field>
      </div>

      <!-- DATA NAME COMPANY -->
      <div *ngIf="tipoBeneficiario === 1" class="grid grid-cols-1 gap-4">
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Razón Social</mat-label>
          <input type="text" matInput formControlName="nombre" placeholder="Ingresa tu Razón Social" autocomplete="off"
            (input)="limpiarNombre($event, 'nombre')" (compositionend)="limpiarNombre($event, 'nombre')">
          <mat-error *ngIf="getErrorMessageName('nombre')">{{ getErrorMessageName('nombre') }}</mat-error>
        </mat-form-field>
      </div>

      <!-- DATA ID -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Tipo documento</mat-label>
          <mat-select required formControlName="tipoID" [(ngModel)]="selectedTipoID" (selectionChange)="onTipoIDChange()">
            <mat-option *ngFor="let tipo of tipoBeneficiario === 0 ? tiposID : tiposIDJuridica" [value]="tipo">
              {{ tipo }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="flex items-center" style="gap: 8px;">
          <span *ngIf="selectedTipoID"
            style="display: inline-flex; align-items: center; padding: 8px 12px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 8px; font-size: 0.85rem; font-weight: 700; color: #1e5a3f; height: 40px;">
            {{ documentPrefix }}
          </span>
          <mat-form-field appearance="outline" class="modern-field flex-1">
            <mat-label>Número identificación</mat-label>
            <input matInput formControlName="numeroID" placeholder="Ej. 12345678" autocomplete="off"
              (input)="limpiarDocumento($event)">
            <mat-error *ngIf="getNumeroIdErrorMessage('numeroID')">{{ getNumeroIdErrorMessage('numeroID') }}</mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- BANK ACCOUNT -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Banco</mat-label>
          <mat-select required formControlName="banco" (selectionChange)="onBancoChange($event.value)">
            <mat-option *ngFor="let banco of bancos" [value]="banco">
              {{ banco.nombre | titlecase }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="this.formCuenta.get('banco')!.hasError('required')">Seleccione un banco</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="modern-field" *ngIf="!isPersonMovilPay">
          <mat-label>Tipo de cuenta</mat-label>
          <mat-select required formControlName="tipoCuenta">
            <mat-option *ngFor="let tipo of tiposCuentas" [value]="tipo.tipoCuentaID">
              {{ tipo.nombre | titlecase }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="this.formCuenta.get('tipoCuenta')!.hasError('required')">Seleccione un tipo de cuenta</mat-error>
        </mat-form-field>
      </div>

      <!-- NUMBER BANK ACCOUNT -->
      <div class="grid grid-cols-1 gap-4">
        <div class="flex items-stretch" style="gap: 8px;">
          <span *ngIf="isPersonMovilPay"
            style="display: flex; align-items: center; padding: 8px 12px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 8px; font-size: 0.85rem; font-weight: 700; color: #1e5a3f;">
            +58
          </span>
          <mat-form-field appearance="outline" class="modern-field flex-1">
            <mat-label>{{ isPersonMovilPay ? 'Número de Teléfono' : 'Número de Cuenta' }}</mat-label>
            <input *ngIf="!isPersonMovilPay" type="text" matInput formControlName="numeroCuenta"
              inputmode="numeric" autocomplete="off"
              (input)="limpiarNumeroCuenta($event)" placeholder="Ej. 0102 0123 4512 3456 7890">
            <input *ngIf="isPersonMovilPay" type="text" matInput formControlName="numeroCuenta"
              inputmode="tel" autocomplete="off"
              (input)="limpiarNumeroCuenta($event)" placeholder="Ej. 0414 123 4567">
            <mat-hint matSuffix style="font-size: 0.75rem;">
              {{ formCuenta.get('numeroCuenta')?.value.length }} / {{ isPersonMovilPay ? 10 : 20 }}
            </mat-hint>
            <mat-error *ngIf="getErrorMessageAccountNumber('numeroCuenta')">{{ getErrorMessageAccountNumber('numeroCuenta') }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
</div>

<!-- Footer -->
<div class="dialog-footer">

  <!-- Vista inicial: Cancelar, Siguiente -->
  <button *ngIf="!viewForm" type="button" (click)="cancel()" class="btn-footer btn-cancel"
    onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
    Cancelar
  </button>
  <button *ngIf="!viewForm" type="button" (click)="generateForm()" class="btn-footer btn-primary"
    [disabled]="formaEnvio === 1 && pagoMovilBloqueadoPorMonto"
    [style.opacity]="(formaEnvio === 1 && pagoMovilBloqueadoPorMonto) ? '0.5' : '1'"
    [style.cursor]="(formaEnvio === 1 && pagoMovilBloqueadoPorMonto) ? 'not-allowed' : 'pointer'"
    onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
    <mat-icon class="btn-icon">arrow_forward</mat-icon>
    Siguiente
  </button>

  <!-- Formulario: Atrás, Cancelar, Guardar -->
  <button *ngIf="viewForm && !esUpdate" type="button" (click)="back()" class="btn-footer btn-back"
    onmouseover="this.style.background='#f0fdf4'" onmouseout="this.style.background='white'">
    <mat-icon class="btn-icon">arrow_back</mat-icon>
    Atrás
  </button>
  <button *ngIf="viewForm" type="button" (click)="cancel()" class="btn-footer btn-cancel"
    onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
    Cancelar
  </button>
  <button *ngIf="viewForm" type="button" (click)="guardarBeneficiario()" class="btn-footer btn-primary"
    onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
    <mat-icon class="btn-icon">save</mat-icon>
    Guardar
  </button>
</div>
